export default "__VITE_ASSET__BwHxo_d0__"